<!--
 * @Descripttion: 轮播图组件
 * @Author: zenghua.wang
 * @Date: 2021-12-20 09:55:38
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 10:48:59
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <el-carousel
      :autoplay="option.autoplay"
      :loop="option.loop"
      :interval="option.duration"
      :arrow="option.arrow"
      :height="styleHeight"
    >
      <el-carousel-item
        v-for="(item,index) in bannerList"
        :key="index"
      >
        <img
          :src="item[swiperUrl]"
          :draggable="false"
          :style="styleImage"
        />
        <div
          v-if="option.showTitle"
          :class="setClass('title')"
          :style="styleTitle"
          v-text="item[swiperTitle]"
        >
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { setPx, isEmpty } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'
import customLoading from '@/dragComponents/directive/loading'

export default {
  name: 'drag-swiper',
  mixins: [bem],
  inject: ['category', 'device'],
  components: {},
  directives: { customLoading },
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: 600
    },
    height: {
      type: [Number, String],
      default: 200
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      component: component,
      dataList: [],
      bannerList: [],
      handle: null
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: this.isFullScreen ? '100%' : setPx(this.width),
          height: setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleHeight() {
      return setPx(this.height)
    },
    styleImage() {
      return {
        width: '100%'
        // opacity: this.option.opacity
      }
    },
    styleTitle() {
      return {
        textAlign: this.option.textAlign,
        fontSize: setPx(this.option.fontSize),
        fontWeight: this.option.fontWeight,
        color: this.option.color
      }
    },
    isFullScreen() {
      return this.category === 'report' ? this.option.fullScreen : false
    },
    swiperTitle() {
      let list = this.option.column.filter((item) => {
        return item.type === 'name'
      })
      return isEmpty(list) ? 'name' : list[0]['prop']
    },
    swiperUrl() {
      let list = this.option.column.filter((item) => {
        return item.type === 'value'
      })
      return isEmpty(list) ? 'value' : list[0]['prop']
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    'option.refresh'(val) {
      if (val) this.loadDataList()
    }
  },
  methods: {
    async loadDataList() {
      if (!this.apiId) {
        this.init()
        return
      }

      // 参数设置
      let restParams = []
      let query = {}

      // 过滤条件
      this.option.reqParams.map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }
        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      try {
        this.loading = true
        let res = await this.$http({
          method: this.option.reqMethod,
          url: mock.getUrl(false) + this.apiId,
          data: restParams,
          params: query
        })
        if (!isEmpty(res.data)) {
          this.dataList = res.data
          this.setOption()
        }
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
        this.option.refresh = false
      }
    },
    init() {
      this.bannerList = mock.swiper.list
    },
    setOption() {
      let list = Object.keys(this.dataList[0])
      if (list.includes(this.swiperTitle) || list.includes(this.swiperUrl)) {
        this.bannerList = this.dataList
      } else {
        this.bannerList = []
      }
    },
    onRefresh() {
      this.handle && clearInterval(this.handle)
      this.handle = null
      if (this.option.refreshTime > 0 && this.disabled) {
        this.handle = setInterval(() => {
          this.loadDataList()
        }, this.option.refreshTime)
      }
    }
  },
  created() {
    this.loadDataList()
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/variables.scss';
.drag-swiper {
  overflow: hidden;
  box-sizing: border-box;

  &-title {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>

